/* istanbul ignore file */

export const DEFAULT_IP_ADDRESS = '217.175.200.36';
export type DEFAULT_IP_ADDRESS = typeof DEFAULT_IP_ADDRESS;
